import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useTheme } from "../../contexts/ThemeContext";
import { getPedidos, getSuscripciones } from "../../services/wordpress/micuenta";

const formatearFecha = (fecha) => {
  if (!fecha) return "-";
  const d = new Date(fecha);
  return isNaN(d.getTime()) ? fecha : d.toLocaleDateString("es-ES");
};

export const ResumenCuenta = () => {
  const auth = useAuth();
  const { colors, mode } = useTheme() || { colors: {}, mode: "light" };
  const isDark = mode === "dark";

  const bgCard = isDark ? "rgba(255,255,255,0.025)" : colors.backgroundColorDetailCourse || "#ffffff";
  const textPrimary = isDark ? "#f1f5f9" : "#1e293b";
  const textSecondary = isDark ? "#8b8a99" : "#64748b";

  const [resumen, setResumen] = useState({ totalPedidos: null, suscripcion: null });
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    if (!auth.apiToken || !auth.wpUrl) {
      setCargando(false);
      return;
    }
    let cancelado = false;
    setCargando(true);
    Promise.all([
      getPedidos({ wpUrl: auth.wpUrl, apiToken: auth.apiToken, page: 1, perPage: 1 }),
      getSuscripciones({ wpUrl: auth.wpUrl, apiToken: auth.apiToken }),
    ])
      .then(([{ total }, suscripciones]) => {
        if (cancelado) return;
        const activa = suscripciones.find((s) => s.estado === "active") || suscripciones[0] || null;
        setResumen({ totalPedidos: total, suscripcion: activa });
      })
      .catch(() => {
        if (!cancelado) setResumen({ totalPedidos: null, suscripcion: null });
      })
      .finally(() => {
        if (!cancelado) setCargando(false);
      });
    return () => {
      cancelado = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.apiToken, auth.wpUrl]);

  const filas = [
    { label: "Pedidos totales", valor: cargando ? "…" : resumen.totalPedidos ?? "-" },
    {
      label: "Suscripción",
      valor: cargando
        ? "…"
        : resumen.suscripcion
          ? resumen.suscripcion.estado
          : "Sin suscripción activa",
      capitalize: !!resumen.suscripcion,
    },
    {
      label: "Próximo pago",
      valor: cargando ? "…" : formatearFecha(resumen.suscripcion?.proximo_pago),
    },
  ];

  return (
    <div
      style={{
        // Este widget está pegado justo debajo del nav — sin borde propio,
        // ambos bloques se leen como uno solo.
        border: isDark ? "1px solid rgba(255,255,255,0.08)" : "1px solid #e2e8f0",
        borderRadius: 16,
        backgroundColor: bgCard,
        padding: 18,
        marginTop: 28,
        display: "flex",
        flexDirection: "column",
        gap: 16,
      }}
    >
      <span
        style={{
          fontSize: 11,
          fontWeight: 700,
          color: textSecondary,
          textTransform: "uppercase",
          letterSpacing: "0.05em",
        }}
      >
        Resumen de cuenta
      </span>
      {filas.map((fila) => (
        <div key={fila.label} style={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <span style={{ fontSize: 10, color: textSecondary, textTransform: "uppercase", letterSpacing: "0.05em" }}>
            {fila.label}
          </span>
          <span
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: textPrimary,
              textTransform: fila.capitalize ? "capitalize" : "none",
            }}
          >
            {fila.valor}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ResumenCuenta;
